import { render, staticRenderFns } from "./BlockBuilder.vue?vue&type=template&id=35e75949&scoped=true"
import script from "./BlockBuilder.vue?vue&type=script&lang=js"
export * from "./BlockBuilder.vue?vue&type=script&lang=js"
import style0 from "./BlockBuilder.vue?vue&type=style&index=0&id=35e75949&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e75949",
  null
  
)

export default component.exports